module.exports = __webpack_public_path__ + "img/burning_card.8ca1a4d8.svg";